module.exports = __webpack_public_path__ + "static/img/industry01.777c38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/industry01.png
// module id = nzIz
// module chunks = 0